import type { TFunction } from "i18next";
import { z } from "zod";

export function buildActivityUpdateSchema(t: TFunction<"activities">) {
  return z
    .object({
      address: z.string(),
      coordinates: z
        .object({
          lat: z.number(),
          lng: z.number(),
        })
        .nullable(),
      avg_price_per_person: z.string(),
      requires_handshake: z.boolean(),
      booking_cutoff_value: z.string(),
      booking_cutoff_unit: z.enum(["hours", "minutes"]),
      is_visible: z.boolean(),
    })
    .superRefine((data, ctx) => {
      const raw = data.booking_cutoff_value.trim();
      if (raw === "") {
        return;
      }
      if (!/^\d+$/.test(raw)) {
        ctx.addIssue({
          code: "custom",
          message: t("zod.bookingCutoffInvalid"),
          path: ["booking_cutoff_value"],
        });
        return;
      }
      const n = Number.parseInt(raw, 10);
      const max = data.booking_cutoff_unit === "hours" ? 168 : 10080;
      if (n < 0 || n > max) {
        ctx.addIssue({
          code: "custom",
          message: t("zod.bookingCutoffRange"),
          path: ["booking_cutoff_value"],
        });
      }
    });
}

export type ActivityDetailFormValues = z.infer<
  ReturnType<typeof buildActivityUpdateSchema>
>;
